import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { IErrorResponse, IGetJobsRequestParams, IGetJobsResponse } from '../../interface';
import { messageQueueService } from '../../services/message-queue';
import { normalizeAxiosError } from '../../utility/axiosErrorHandler';

export const fetchMessageQueueJobs = createAsyncThunk<
  IGetJobsResponse,
  IGetJobsRequestParams,
  { rejectValue: IErrorResponse }
>('message-queue/fetch-jobs', async (params, { rejectWithValue }) => {
  try {
    const response = await messageQueueService.fetchJobs(params);
    return response.data;
  } catch (err) {
    return rejectWithValue(
      normalizeAxiosError(
        err,
        i18n.t('toast.failed_to_fetch_message_queue_jobs', 'Failed to fetch message queue jobs.'),
      ),
    );
  }
});

const messageQueueActions = {
  fetchMessageQueueJobs,
};

export default messageQueueActions;
